import { useState } from 'react'
import { newHttpService } from '../../services/new-http-service'
import ObjectiveTable from '../../cmps/objective/objective-table'
import { ObjectiveFormModal } from '../../cmps/objective/objective-form-modal'
import { Spinner } from '../../cmps/util-cmps/spinner'
import { useCachedFetch } from '../../hooks/use-cached-fetch'

const GET_OBJECTIVES = `
{
  objectives {
    id
    name
    objectiveNumber
    domain
    domainAbbreviation
    abbreviation
    description
    risk
    frequency
    type
    ITDependency
    testType
    specification
    populationType
    failureCriteria
    testPlan
    isKeyObjective
  }
}
`

export const ObjectivesPage: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [objectiveToEdit, setObjectiveToEdit] = useState<any>(null)

    const { data, isLoading, hasError, refetch } = useCachedFetch(
        'objectives',
        async () => {
            const result = await newHttpService.graphql('auditech', GET_OBJECTIVES)
            return result.objectives as any[]
        }
    )

    const openCreateModal = () => {
        setObjectiveToEdit(null)
        setIsModalOpen(true)
    }

    const openEditModal = (objective: any) => {
        setObjectiveToEdit(objective)
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setIsModalOpen(false)
        setObjectiveToEdit(null)
    }

    const handleSuccess = () => {
        closeModal()
        refetch()
    }

    return <div className="tablePageContainer">
        <div className="page-header">
            <p className="tableSubtitle">Manage audit objectives and their configurations.</p>
            <button className="add-btn" onClick={openCreateModal}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Create Objective
            </button>
        </div>

        {isLoading && <Spinner />}
        {!isLoading && !hasError && <ObjectiveTable data={data || []} onDataChange={refetch} onEditClick={openEditModal} />}
        {!isLoading && hasError && <div className="error-hint">Failed to load data. Try refreshing the page or re-logging in.</div>}

        {isModalOpen && (
            <ObjectiveFormModal
                key={objectiveToEdit?.id || 'create'}
                objectives={data || []}
                objectiveToEdit={objectiveToEdit}
                onSuccess={handleSuccess}
                onClose={closeModal}
            />
        )}
    </div>
}
